import { ReactNode } from 'react'
import { cn } from '../../utils/cn'
import {
  InboxIcon,
  MagnifyingGlassIcon,
  ExclamationCircleIcon,
} from '@heroicons/react/24/outline'
import Button from './Button'

export interface EmptyStateProps {
  variant?: 'default' | 'search' | 'error'
  icon?: ReactNode
  title: string
  description?: string
  actionLabel?: string
  onAction?: () => void
  className?: string
}

export default function EmptyState({
  variant = 'default',
  icon,
  title,
  description,
  actionLabel,
  onAction,
  className,
}: EmptyStateProps) {
  const defaultIcons = {
    default: <InboxIcon className="w-12 h-12 text-gray-400" />,
    search: <MagnifyingGlassIcon className="w-12 h-12 text-gray-400" />,
    error: <ExclamationCircleIcon className="w-12 h-12 text-red-400" />,
  }

  const displayIcon = icon || defaultIcons[variant]

  return (
    <div className={cn('flex flex-col items-center justify-center py-12 px-4 text-center', className)}>
      <div className="mb-4">{displayIcon}</div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
      {description && <p className="text-sm text-gray-500 mb-6 max-w-md">{description}</p>}
      {actionLabel && onAction && (
        <Button onClick={onAction} variant="primary">
          {actionLabel}
        </Button>
      )}
    </div>
  )
}
